import React from 'react'
import DE from 'country-flag-icons/react/3x2/DE'
import ES from 'country-flag-icons/react/3x2/ES'
import FR from 'country-flag-icons/react/3x2/FR'
import GB from 'country-flag-icons/react/3x2/GB'
import IT from 'country-flag-icons/react/3x2/IT'
import NL from 'country-flag-icons/react/3x2/NL'
import PL from 'country-flag-icons/react/3x2/PL'
import PT from 'country-flag-icons/react/3x2/PT'

// Drawn inline rather than as emoji flags, which have no glyphs on Windows.
// Decorative: every flag is rendered beside the language's own name, so
// announcing it again would just repeat that name.
const FLAGS = {
    en: GB,
    de: DE,
    es: ES,
    fr: FR,
    it: IT,
    nl: NL,
    pl: PL,
    pt: PT,
}

export default function FlagIcon({ code }) {
    const Flag = FLAGS[code]
    if (!Flag) return null
    return (
        <Flag
            width="21"
            height="14"
            aria-hidden="true"
            focusable="false"
            style={{ boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.15)' }}
        />
    )
}
